'use strict';

var React = require('react');

var SvgIqMajor = function SvgIqMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.896 2.141a.98.98 0 1 0 1.387-1.386.98.98 0 0 0-1.387 1.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.812 12.676a7.055 7.055 0 0 1 0-9.97 7.025 7.025 0 0 1 4.462-2.045.9.9 0 0 1 .132 1.795 5.225 5.225 0 0 0-3.321 1.521 5.255 5.255 0 0 0 0 7.425 5.256 5.256 0 0 0 5.491 1.227 2.95 2.95 0 1 1 .674 1.67 7.057 7.057 0 0 1-7.438-1.624zm8.893.551a1.15 1.15 0 1 1 1.627-1.626 1.15 1.15 0 0 1-1.627 1.626z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.651 19.408a.9.9 0 0 1 .22-1.786 5.242 5.242 0 0 0 4.36-1.496 5.255 5.255 0 0 0 0-7.425 5.257 5.257 0 0 0-5.556-1.204 2.95 2.95 0 1 1-.621-1.69 7.057 7.057 0 0 1 7.45 1.621 7.055 7.055 0 0 1 0 9.97 7.042 7.042 0 0 1-5.853 2.01zm-4.737-12.598a1.15 1.15 0 1 0 1.627 1.627 1.15 1.15 0 0 0-1.627-1.627z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.646,
    cy: 17.934,
    r: 0.94
  }));
};

exports.SvgIqMajor = SvgIqMajor;
